<template>
    <div class="row">
        <div class="col-3">
            <img v-if="entry.fields.Profilbild" :alt="entry.fields.Name" :src="entry.fields.Profilbild + '?width=60'"
                 :title="entry.fields.Name" class="comment-profile-pic"/> <span class="comment-profile-name">{{
                entry.fields.Name
            }}</span>
        </div>
        <div class="col-9 card">
            <div class="card-body">
                <small class="card-subtitle mb-2 text-muted">{{ formatDate(entry.created) }}</small>
                <p class="card-text">{{ entry.fields.Kommentar }}</p>
                <a class="card-link btn-link" href="" v-bind:class="{ disabled: entry.alreadyLiked }"
                   @click="like($event, entry)">{{ likeText }} ({{ entry.likeCount }})</a> <a v-if="showReply"
                                                                                              class="card-link"
                                                                                              href=""
                                                                                              @click="reply($event)">{{
                    replyText
                }}</a> <a v-if="entry.childrenCount > 0" class="card-link" href=""
                          @click="showChildren($event, entry)">{{ showAnswersText }} ({{ entry.childrenCount }})</a>
            </div>
            <md-forms-entry-list-item v-for="child in children"
                                      v-if="childrenShow"
                                      :key="child.id"
                                      :date-format="dateFormat"
                                      :entry="child"
                                      :form-id="formId"
                                      :form-load-error-text="formLoadErrorText"
                                      :language="language"
                                      :like-text="likeText"
                                      :login-text="loginText"
                                      :login-url="loginUrl"
                                      :mode="mode"
                                      :page-id="pageId"
                                      :reply-text="replyText"
                                      :send-text="sendText"
                                      :show-answers-text="showAnswersText"
                                      :show-reply="false"
                                      :website-id="websiteId"></md-forms-entry-list-item>
            <div v-if="loading">
                <div class="spinner-border text-primary" role="status">
                    <span class="visually-hidden">Loading...</span>
                </div>
            </div>
            <md-forms-form-builder v-if="entry.reply" :form-id="formId" :form-load-error-text="formLoadErrorText"
                                   :language="language" :login-text="loginText" :login-url="loginUrl" :mode="mode"
                                   :page-id="pageId" :parent-id="entry.id" :send-text="sendText" :website-id="websiteId"
                                   field-cols="9" label-cols="3" @submitted="reload"></md-forms-form-builder>
        </div>
    </div>
</template>

<script>
import Axios from 'axios';
import moment from 'moment';
import MdFormsFormBuilder from './FormBuilder.vue';

export default {
    name: 'MdFormsEntryListItem',
    components: { MdFormsFormBuilder },
    props: {
        entry: {
            type: Object,
            required: true
        },
        showReply: {
            type: Boolean,
            default: false
        },
        formId: {
            type: String,
            required: true
        },
        pageId: {
            type: String,
            required: true
        },
        dateFormat: {
            type: String
        },
        replyText: {
            type: String,
            required: true,
        },
        likeText: {
            type: String,
            required: true
        },
        showAnswersText: {
            type: String,
            required: true
        },
        websiteId: {
            type: String,
            required: true
        },
        formLoadErrorText: {
            type: String,
            required: true,
        },
        sendText: {
            type: String,
            required: true
        },
        loginText: {
            type: String,
            required: true
        },
        loginUrl: {
            type: String,
        },
        language: {
            type: String,
            required: true
        },
        mode: {
            type: String,
            default: 'entry'
        }
    },
    data() {
        return {
            loading: false,
            children: [],
            childrenShow: false
        };
    },
    methods: {
        showChildren(e) {
            if (e) {
                e.preventDefault();
            }

            if (!this.childrenShow && this.children.length === 0) {
                this.loading = true;
                Axios.get(`/umbraco/mdforms/${this.mode}/search?formId=${this.formId}&pageId=${this.pageId}&parentId=${this.entry.id}`).then(response => {
                    this.children = response.data.data;
                    this.loading = false;
                    this.entry.reply = false;
                    this.childrenShow = true;
                });
            } else {
                this.childrenShow = !this.childrenShow;
            }
        },
        reply(e) {
            e.preventDefault();
            this.$emit('reply', this.entry.id);
        },
        reload() {
            this.showChildren();
        },
        formatDate(input) {
            return moment(input).format(this.dateFormat)
        },
        like(e, item) {
            e.preventDefault();
            Axios.post(`/umbraco/mdforms/${this.mode}/IncreaseLike?entryId=${item.id}&formId=${this.formId}`)
                .then(response => {
                    item.alreadyLiked = true;
                    if (response.data !== -1) {
                        item.likeCount = response.data;
                    }
                });
        }
    }
}
</script>